import { useMemo } from "react";
import { useQuery } from "urql";
import { graphql } from "@acto/gql";
import { hasClient, Meeting } from "@acto/taskpane/core/domain";

const CancelledMeetingsQuery = graphql(`
  query GetCancelledMeetings($clientId: ID!) {
    cancelledMeetings(clientId: $clientId) {
      id
      __typename
      scheduledDate
      scheduledStartTime
      scheduledEndTime
      occurrenceDate
      client {
        id
        legacyId
        __typename
        name
        externalReference
      }
    }
  }
`);

export function useCancelledMeetings({ clientId }: { clientId: string }) {
  const [result, refetch] = useQuery({
    query: CancelledMeetingsQuery,
    variables: { clientId },
  });

  const meetings = useMemo(
    () => result.data?.cancelledMeetings.filter(hasClient).map(Meeting.fromGraphql),
    [result.data],
  );

  return {
    data: meetings,
    isFetching: result.fetching || Boolean(result.stale),
    isPending: (result.fetching || Boolean(result.stale)) && !result.data,
    error: result.error,
    refetch,
  };
}
